<template>
  <div>
    <div class="comment-box">
      <!-- 评论输入框 -->
      <div class="toolbar">
        <!-- 表情选择 -->
        <div id="emoji">
          <span @click="toggleEmojiPicker">😀</span>
          <emoji-picker
            v-show="showEmojiPicker"
            @select="addEmoji"
          ></emoji-picker>
        </div>
        <!-- 图片上传 -->
        <image-upload
          :image-url="form.coverImage"
          v-if="false"
          @upload-success="handleUploadSuccess"
          @upload-error="handleUploadError"
        />
      </div>
      <div class="comment-input">
        <textarea
          v-model="form.content"
          placeholder="写下你的评论..."
          @keyup.enter="submitComment"
        ></textarea>
      </div>

      <!-- 工具栏（表情 + 图片上传） -->
      <div class="send">
        <!-- 提交按钮 -->
        <el-button  @click="submitComment" type="primary">发 送</el-button>
      </div>

      <!-- 预览图片 -->
      <div v-if="previewImage" class="image-preview">
        <img :src="previewImage" alt="Preview" />
        <button @click="removeImage">×</button>
      </div>
    </div>
    <div class="historyComment">
      <history-comment @deleteSuccess="deleteSuccess" :comments="comments" />
      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="pageNum"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageSize"
          layout="total,sizes, prev, pager, next"
          :total="total"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import { Picker } from 'emoji-mart-vue';
import HistoryComment from '@/components/comments/historyComment.vue';
import {
  addComment,
  delComment,
  getComment,
  fileUpLoad,
} from '@/API/news/news';
import ImageUpload from './component/ImageUpload.vue';
export default {
  components: {
    HistoryComment,
    'emoji-picker': Picker,
    ImageUpload,
  },
  data() {
    return {
      form: {
        articleId: this.newsId,
        userId: JSON.parse(localStorage.getItem('ordinaryUser')).userDetail
          .userId
          ? JSON.parse(localStorage.getItem('ordinaryUser')).userDetail.userId
          : '',
        username: JSON.parse(localStorage.getItem('ordinaryUser')).userDetail
          .username
          ? JSON.parse(localStorage.getItem('ordinaryUser')).userDetail.username
          : '',
        content: '',
        avatar: JSON.parse(localStorage.getItem('ordinaryUser')).userDetail
          .imgurl
          ? JSON.parse(localStorage.getItem('ordinaryUser')).userDetail.imgurl
          : '',
      },
      uploadUrl: require('@/assets/recycling/echartsMap/imgUpload.png'),
      showEmojiPicker: false, // 是否显示表情选择器
      previewImage: null, // 预览图片（Base64）
      selectedFile: null, // 选中的图片文件
      comments: [],
      articleId:'',
      pageNum: 1,
      pageSize: 10,
      total: 0,
    };
  },
  props: {
    newsId: {
      type: Number,
      default: 0,
    },
  },
  watch: {
    newsId: {
      immediate: true,
      handler: function (val) {
        this.articleId = val
        this.getComments(val);
      },
    },
  },
  mounted() {
    let that = this;
    // 获取要隐藏的元素
    const element = document.getElementById('emoji');
    // 全局点击事件监听
    document.addEventListener('click', function (event) {
      // 如果点击的不是元素本身或元素内部，且元素当前是显示的
      if (!element.contains(event.target) && that.showEmojiPicker) {
        that.showEmojiPicker = false;
      }
    });
    // 元素自身的点击事件 - 阻止冒泡以避免立即隐藏
    element.addEventListener('click', function (event) {
      event.stopPropagation();
    });
  },
  methods: {
    getComments(id) {
      let parmrs = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
      };
      getComment(id, parmrs).then((res) => {
        if (res.code === 200) {
          console.log(res.data, '根据文章id获取评论');
          this.total = res.data.total
          this.pageNum = res.data.current
          this.pageSize = res.data.pageSize
          this.comments = res.data.records
        }
      });
    },
    handleEmojiClick(event, emoji) {
      event.stopPropagation();
      // 处理表情选择逻辑...
    },
    // 切换表情选择器
    toggleEmojiPicker() {
      this.showEmojiPicker = !this.showEmojiPicker;
    },

    // 添加表情到输入框
    addEmoji(emoji) {
      this.form.content += emoji.native;
    },

    // 触发文件选择
    triggerFileInput() {
      this.$refs.fileInput.click();
    },

    // 处理图片上传
    handleImageUpload(e) {
      const file = e.target.files[0];
      if (!file) return;

      this.selectedFile = file;

      // 预览图片（Base64）
      const reader = new FileReader();
      reader.onload = (event) => {
        this.previewImage = event.target.result;
      };
      reader.readAsDataURL(file);
    },

    // 移除图片
    removeImage() {
      this.previewImage = null;
      this.selectedFile = null;
    },

    // 提交评论
    submitComment() {
      if (!this.form.content.trim()) {
        alert('评论内容不能为空！');
        return;
      }
      addComment(this.form).then((res) => {
        if (res.code === 200) {
          this.$message.success('评论成功，待审核通过后展示！！！');
        }else {
          this.$message.error(res.message);
        }
      });
      // 清空输入
      this.form.content = '';
      this.getComments(this.articleId);
    },
    handleUploadSuccess({ url, fileName }) {
      console.log(url, fileName, 'asdadadasdas');
      this.form.coverImage = url;
      this.form.fileName = fileName;
      this.$message.success('图片上传成功');
    },
    handleUploadError(error) {
      console.error('上传失败:', error);
      this.$message.error('图片上传失败');
    },
    // 分页变更
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.pageSize = val;
      this.getComments(this.articleId);
    },
    // 分页变更
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.pageNum = val;
      this.getComments(this.articleId);
    },
    deleteSuccess(){
      this.getComments(this.articleId);
    }
  },
};
</script>

<style lang="less" scoped>
.comment-box {
  border: 1px solid #ddd;
  padding: 10px;
  border-radius: 5px;
}

.comment-input textarea {
  width: 100%;
  min-height: 80px;
  padding: 8px;
  border-radius: 4px;
  resize: vertical;
}

.toolbar {
  display: flex;
  gap: 10px;
  align-items: center;
  position: relative;
}

.toolbar button {
  border: none;
  border-radius: 4px;
  cursor: pointer;
}
.toolbar span {
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 16px;
}
.toolbar img {
  width: 18px;
  height: 16px;
}

.image-preview {
  position: relative;
  margin-top: 10px;
}

.image-preview img {
  max-width: 200px;
  max-height: 200px;
  border-radius: 4px;
}

.image-preview button {
  position: absolute;
  top: 0;
  right: 0;
  background: red;
  color: white;
  border: none;
  border-radius: 50%;
  width: 20px;
  height: 20px;
  cursor: pointer;
}
/deep/.emoji-mart {
  position: absolute;
  width: 339px;
  top: -435px;
  left: -10px;
}
/deep/.emoji-mart-preview {
  display: none;
}
.send {
  display: flex;
  justify-content: end;
  width: 100%;
}
.historyComment {
  margin: 20px 0;
  .pagination {
    display: flex;
    justify-content: end;
    padding-top: 20px;
  }
}
</style>
